export const screening = (
  state = {
    data: [],
    loading: false,
    publish: false,
    create: false,
    usuariosAdm: [],
    menu: null,
    allTabs: [],
    searchList: []
  },
  action
) => {
  switch (action.type) {
    case "INIT_CARDS": {
      return { ...state, loading: true };
    }
    case "INIT": {
      return {
        ...state,
        publish: false,
        create: false,
        menuNew: false,
        editMenu: false,
      };
    }
    case "PUBLISH_TAB": {
      return { ...state, publish: true };
    }
    case "CREATE_MENU": {
      return { ...state, menuNew: true, editMenu: true, menu: action.payload };
    }
    case "EDIT_MENU": {
      return { ...state, editMenu: true };
    }
    case "DELETE_MENU": {
      return { ...state, editMenu: true };
    }
    case "GET_USUARIOS_ADM": {
      return {
        ...state,
        usuariosAdm: action.payload,
      };
    }
    case "CREATE_TAB": {
      return { ...state, create: true };
    }
    case "GET_CARDS": {
      return { ...state, data: action.payload, loading: false };
    }
    case "GET_CARDS_ERROR": {
      return { ...state, error: action.payload, loading: false };
    }
    case "ENABLE_LOCAL_FILE_TAB": {
      window.location.reload();
      return { ...state };
    }
    case "GET_ALL_TABS": {
      return { ...state, allTabs: action.payload };
    }
    case "SEARCH": {
      return { ...state, searchList: action.payload };
    }
    default: {
      return state;
    }
  }
};
